export default __webpack_public_path__ + "static/media/Spring21_10.a933d7f1.png";